import {AbstractPart} from "./AbstractPart";
import {getNextId} from "../../../../util/misc";
import radioHtml from './radio.html?raw';

export let template = radioHtml;

export class viewModel extends AbstractPart {
    private name: string = 'radio-' + getNextId();
    private options: any[];

    constructor(params: any) {
        super(params);
        this.options = this.getOptions();
        switch (this.value()) {
            case undefined:
            case null:
                this.value(this.options.find(o => o.selected)?.value)
        }
    }

    override isValid(): boolean {
        const a = !!this.value();
        this.et.update(!a, this.value, 'Mangler verdi');
        return a;
    }

    protected override getOptions(): any[] {
        const options = this.parameters[2]?.split('|') || [];
        const selected = this.value() || this.parameters[3];
        const ret = super.getOptions(options, selected);
        this.value(ret.find(o => o.selected)?.value)
        return ret;
    }
}
